<template>
  <Grid
    class="plant-grid"
    :data-items="plants"
    :columns="columns"
    @rowclick="changeSelection"
    data-cy="plant-grid"
  >
    <template v-slot:SelectHeaderCell>
      <th>
        <input
          type="checkbox"
          :checked="allPlantsSelected"
          ref="selectAllCheckbox"
          @change="onHeaderSelectionChange"
          :disabled="props.selectionDisabled"
          data-cy="select-all-checkbox"
        />
      </th>
    </template>
    <template v-slot:selectedCell="{ props: { dataItem, field } }">
      <td class="k-table-td">
        <input
          type="checkbox"
          v-model="dataItem[field]"
          :disabled="props.selectionDisabled"
          data-cy="select-checkbox"
        />
      </td>
    </template>
    <template v-slot:PlantStatusCell="{ props: { dataItem, field } }">
      <td class="k-table-td">
        {{ EnumCompanyStatus[dataItem[field]] }}
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import {
  Grid,
  type GridColumnProps,
  type GridRowClickEvent,
  type GridSelectionChangeEvent,
} from "@progress/kendo-vue-grid";
import { ref, computed } from "vue";
import type { PlantWithSelection } from "@/api/scheduleB";
import { EnumCompanyStatus } from "@/Domain/EnumCompanyStatus";

const props = defineProps<{
  plants: PlantWithSelection[];
  selectionDisabled?: boolean;
}>();

const columns = ref<GridColumnProps[]>([
  {
    field: "selected",
    width: "50px",
    sortable: false,
    filterable: false,
    headerCell: "SelectHeaderCell",
    cell: "selectedCell",
  },
  {
    title: "Plant Name",
    field: "Name",
  },
  {
    title: "Production Type",
    field: "PlantType",
  },
  {
    title: "Plant Status",
    field: "Status",
    cell: "PlantStatusCell",
  },
]);

const allPlantsSelected = computed(() => {
  return props.plants.every((plant) => plant.selected);
});

const onHeaderSelectionChange = function (event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  props.plants.forEach((plant) => {
    plant.selected = checked;
  });
};

const changeSelection = function (
  event: GridSelectionChangeEvent | GridRowClickEvent
) {
  if (props.selectionDisabled) return;

  const plant = event.dataItem as PlantWithSelection;
  if (!plant) return;
  plant.selected = !plant.selected;
};
</script>
